(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smael-collection"] && !Shopify.designMode) return;
  try {
    
/* Sem formulário ou drawer extra: adiciona a variante e abre o carrinho nativo. */
(() => {
  if (customElements.get('smael-collection')) return;
  customElements.define('smael-collection', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.setupInviewLift();
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-add-variant]');
        if (!button || !this.contains(button) || button.disabled) return;
        const status = button.closest('.smc-action').querySelector('.smc-status');
        const label = button.querySelector('span');
        const original = label.textContent;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        label.textContent = this.dataset.loading;
        status.hidden = true;
        try {
          const response = await fetch(this.dataset.cartAdd, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: button.dataset.addVariant, quantity: 1 }] }),
            signal: this.controller.signal
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error(result.description || this.dataset.error);
          if (this.isConnected) window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected) {
            status.textContent = error.message || this.dataset.error;
            status.hidden = false;
          }
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          label.textContent = original;
        }
      }, { signal: this.controller.signal });
      this.addEventListener('click', (event) => {
        const openBtn = event.target.closest('[data-specs-toggle]');
        if (openBtn) {
          const sheet = this.querySelector('#' + CSS.escape(openBtn.dataset.specsTarget));
          this.openSpecsSheet(sheet);
          return;
        }
        if (event.target.closest('[data-specs-close]') || event.target.closest('[data-specs-backdrop]')) {
          this.closeSpecsSheet();
        }
      }, { signal: this.controller.signal });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeSpecsSheet();
      }, { signal: this.controller.signal });
    }
    openSpecsSheet(sheet) {
      if (!sheet) return;
      this.closeSpecsSheet();
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      this.querySelector('[data-specs-backdrop]')?.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    closeSpecsSheet() {
      this.querySelectorAll('.smc-specs-sheet.is-open').forEach((sheet) => {
        sheet.classList.remove('is-open');
        sheet.setAttribute('aria-hidden', 'true');
      });
      this.querySelector('[data-specs-backdrop]')?.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
    setupInviewLift() {
      /* Detecção por scroll direta (rAF-throttled). Chegamos a testar um pré-filtro via IntersectionObserver pra economizar
         cálculo, mas o IntersectionObserver se mostrou pouco confiável (callback não dispara em alguns navegadores/webviews),
         o que deixava cards presos sem nunca ativar o salto. Checar todos os cards a cada frame de scroll é mais barato do
         que parece — poucas dezenas de getBoundingClientRect — e sempre funciona.
         IMPORTANTE #1: a lista de cards é buscada de novo a cada update(), nunca guardada de uma vez só — se o app de carrinho
         (ou qualquer coisa) re-renderizar esta seção via AJAX depois da carga inicial, uma lista fixa ficaria com referências
         órfãs (fora do DOM) e o salto parava de funcionar silenciosamente, sem erro nenhum no console.
         IMPORTANTE #2: a checagem de hover é reavaliada a cada scroll (não decidida uma única vez no connectedCallback).
         Um veto único e precoce é arriscado: se o navegador ainda não tiver "assentado" no modo touch bem no instante em
         que o elemento conecta, o listener nunca seria registrado e o card nunca mais saltaria — mesmo sendo mobile de verdade. */
      const isHoverCapable = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      let ticking = false;
      const update = () => {
        ticking = false;
        if (isHoverCapable()) return;
        const vh = window.innerHeight;
        const cards = this.querySelectorAll('.smc-card');
        cards.forEach((card) => {
          const rect = card.getBoundingClientRect();
          const visibleTop = Math.max(rect.top, 0);
          const visibleBottom = Math.min(rect.bottom, vh);
          const visibleHeight = Math.max(0, visibleBottom - visibleTop);
          const referenceHeight = Math.min(rect.height, vh) || 1;
          const visibleRatio = visibleHeight / referenceHeight;
          const onScreen = rect.bottom > 0 && rect.top < vh;
          /* Só ativa quando boa parte do card já foi vista (evita o salto disparar cedo demais). */
          if (visibleRatio >= 0.72) {
            card.classList.add('is-inview');
          } else if (!onScreen) {
            card.classList.remove('is-inview');
          }
        });
      };
      /* setTimeout em vez de requestAnimationFrame: rAF depende do ciclo de pintura visual do navegador, que pode ficar
         suspenso/atrasado em abas em segundo plano, alguns webviews e ambientes de teste automatizados — fazendo o salto
         nunca ativar mesmo com o listener funcionando. setTimeout roda de forma garantida independente da pintura. */
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        setTimeout(update, 100);
      };
      window.addEventListener('scroll', onScroll, { passive: true, signal: this.controller.signal });
      window.addEventListener('resize', onScroll, { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.closeSpecsSheet();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verdant-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('verdant-scent-hero')) return;

  customElements.define('verdant-scent-hero', class extends HTMLElement {
    connectedCallback() {
      this.dispose?.();

      const controller = new AbortController();
      const { signal } = controller;

      let timer;
      let imageTimer;
      let imageIndex = 0;
      let frame;
      let observer;
      let ready = false;
      let index = 0;
      let paused = false;
      let selected = false;

      const stop = () => {
        clearInterval(timer);
        clearInterval(imageTimer);
        timer = undefined;
      };

      const initialize = () => {
        if (ready || !this.isConnected) return;

        const slides = [...this.querySelectorAll('[data-phrase]')];
        const imageSlides = [...this.querySelectorAll('[data-image-slide]')];
        const media = this.querySelector('.vh-media');
        if (!this.querySelector('.vh-content')) return;
        if (!slides.length && !imageSlides.length) return;

        ready = true;
        observer?.disconnect();

        const button = this.querySelector('.vh-pause');

        const show = (next) => {
          index = next;

          slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === index);
            slide.setAttribute('aria-hidden', String(i !== index));
          });
        };

        const showImage = (next) => {
          imageIndex = next;
          imageSlides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === imageIndex);
            slide.setAttribute('aria-hidden', String(i !== imageIndex));
          });
          const color = imageSlides[imageIndex]?.dataset.dividerColor;
          if (color) media?.style.setProperty('--vh-active-divider', color);
        };

        const advanceImage = () => {
          // Não mostra imagens vazias, com erro ou ainda sem carregar.
          for (let step = 1; step < imageSlides.length; step++) {
            const next = (imageIndex + step) % imageSlides.length;
            const image = imageSlides[next].querySelector('img');
            if (image?.complete && image.naturalWidth > 0) {
              showImage(next);
              return;
            }
          }
        };

        const start = () => {
          stop();
          if (paused || document.hidden) return;
          if (slides.length > 1 && !selected) {
            timer = setInterval(
              () => show((index + 1) % slides.length),
              Math.max(2000, Number(this.dataset.delay) || 3000)
            );
          }
          if (imageSlides.length > 1) {
            imageTimer = setInterval(advanceImage, 2000);
          }
        };

        show(0);
        if (imageSlides.length) showImage(0);

        if (button) {
          button.hidden = slides.length < 2 && imageSlides.length < 2;
          button.setAttribute('aria-pressed', 'false');
          button.firstElementChild.textContent = 'Ⅱ';

          button.addEventListener('click', () => {
            paused = !paused;

            button.setAttribute('aria-pressed', String(paused));
            button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';

            start();
          }, { signal });
        }

        document.addEventListener(
          'visibilitychange',
          start,
          { signal }
        );

        // Ao editar uma frase, mantém esse bloco visível.
        document.addEventListener('shopify:block:select', (event) => {
          const next = slides.findIndex(
            slide => slide.dataset.blockId === event.detail?.blockId
          );

          if (next < 0) return;

          selected = true;
          show(next);
          start();
        }, { signal });

        document.addEventListener('shopify:block:deselect', (event) => {
          const belongsToSection = slides.some(
            slide => slide.dataset.blockId === event.detail?.blockId
          );

          if (!belongsToSection) return;

          selected = false;
          start();
        }, { signal });

        start();
      };

      // Aguarda os elementos internos antes de iniciar o carrossel.
      observer = new MutationObserver(initialize);
      observer.observe(this, {
        childList: true,
        subtree: true
      });

      frame = requestAnimationFrame(initialize);

      this.dispose = () => {
        stop();
        cancelAnimationFrame(frame);
        observer.disconnect();
        controller.abort();
      };
    }

    disconnectedCallback() {
      this.dispose?.();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
